<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="row sm-gutters">
            <!-- Menu -->
            <div class="col-sm-12 col-md-2">
                <AppMenu></AppMenu>
            </div>
            <!-- Messages -->
            <div class="col-sm-12 col-md-10">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ t("messagesLabel") }}&nbsp;({{ getSystemMessagesCount
                            }}&nbsp;{{ t("itemsLabel") }})</h5>
                        <button class="btn btn-primary" @click.prevent="resetSystemMessages">{{ t("clearAllLabel")
                            }}</button>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ t("dateLabel") }}</th>
                                        <th>{{ t("typeLabel") }}</th>
                                        <th>{{ t("messageLabel") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(message) in getSystemMessages" :key="message.date">
                                        <td>{{ parseUnixMsTime(message.date) }}</td>
                                        <td>
                                            <div class="icon">
                                                <i v-if="!message.error" class="icon ion-md-lock"></i>
                                                <i v-else class="icon ion-md-alert"></i>
                                            </div>
                                        </td>
                                        <td>{{ message.mess }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from '@/components/ui/AppMenu.vue';
import UiUtils from "@/assets/js/ui_utils.js";
import I18n from "@/lang/i18n.js";

export default {
    components: {
        AppMenu
    },
    methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        parseUnixMsTime(itemTime) {
            return UiUtils.parseUnixMsTime(itemTime);
        },
        resetSystemMessages() {
            this.$store.commit("resetSystemMessages");
        }
    },
    computed: {
        getUserLanguage() {
            const user = this.$store.getters["getUser"];
            return user.lang.toUpperCase();
        },
        getSystemMessages() {
            const messages = this.$store.getters["getSystemMessages"];
            const localMessages = [];
            // copy messages to avoid ercursive updates
            for (let cnt = 0; cnt < messages.length; cnt ++) {
                localMessages.push(messages[cnt]);
            }
            // order descending
            UiUtils.sortByDate(localMessages, "date", true).reverse();
            return localMessages;
        },
        getSystemMessagesCount() {
            return this.getSystemMessages.length;
        }
    }
}
</script>
